import { DefaultCellHeaderRightAlignNoElipsis } from "app/components/React/Table/headerCells";
import { tableHeaderCellStyles } from "app/pages/sales-intelligence/pages/home/components/styles";
import styled from "styled-components";

export const HeaderCellRightAlign = styled(DefaultCellHeaderRightAlignNoElipsis)`
    ${tableHeaderCellStyles}
`;
